import ProjectForm from '~/components/forms/ProjectForm';
import ProjectLoader from '~/components/loader/ProjectLoader';
import { useDefaultProjectRedirect } from '~/hooks/nav/useDefaultProjectRedirect';

export function DefaultProjectRedirect({ targetPath }: { targetPath: string }) {
  const { isRedirecting, hasNoProjects } = useDefaultProjectRedirect({ targetPath });

  return (
    <div className="m-auto h-full w-11/12">
      {isRedirecting ?
        // We're either loading or waiting to route, so show the loader.
        <div className="flex h-full items-center justify-center">
          <ProjectLoader delay={0.5} />
        </div>
      : hasNoProjects ?
        <div className="flex flex-col items-start justify-start py-12">
          <div className="mb-2 text-2xl font-bold tracking-wide">Welcome to Stably!</div>
          <div className="text-gray-600 dark:text-gray-300">
            Let&apos;s create your project. This is where your tests will live.
          </div>
          <div className="mt-8">
            <ProjectForm />
          </div>
        </div>
      : null}
    </div>
  );
}

// Default export required for page components that may import this
export default DefaultProjectRedirect;
